module.exports = __webpack_public_path__ + "img/2-logo@2x.c4cb0513.png";